// extracted by mini-css-extract-plugin
export default {"howItWorks":"how-it-works_howItWorks__5eRFI","icon":"how-it-works_icon__cCVWr","content":"how-it-works_content__SWpMf"};